import { SettingsApi } from 'src/orchd-client';

import { axiosInstance } from 'src/utils/axios';

export const settingsApi = SettingsApi({}, '/api', axiosInstance);
